// Base URL configuration
export const BASE_URL =
  process.env.NODE_ENV === 'production'
    ? 'http://localhost:5000' // Development URL
    : 'https://dev3-api.qickgenerate.com'; // Production URL

// Environment configuration for different deployment environments
export const ENV_CONFIG = {
  // Development environment
  development: {
    API_BASE_URL: BASE_URL,
    DEBUG: true,
    LOG_LEVEL: 'debug',
  },

  // Production environment
  production: {
    API_BASE_URL: BASE_URL,
    DEBUG: false,
    LOG_LEVEL: 'error',
  },

  // Test environment (if needed)
  test: {
    API_BASE_URL: BASE_URL,
    DEBUG: true,
    LOG_LEVEL: 'debug',
  },
};

// Get current environment configuration
export const getCurrentEnvConfig = () => {
  const env = process.env.NODE_ENV || 'development';
  return ENV_CONFIG[env as keyof typeof ENV_CONFIG] || ENV_CONFIG.development;
};

// Helper function to get base URL for authentication
export const getAuthBaseUrl = (): string => {
  return window.location.origin;
};

// Helper function to check if in development mode
export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV === 'development';
};

// Helper function to check if in production mode
export const isProduction = (): boolean => {
  return process.env.NODE_ENV === 'production';
};
